import { apiGet } from '@/services/apiClient';
import type { SyncJobsPage, SyncJobsQuery } from '../types';

/**
 * `CventSyncController` is declared with `[Route("[controller]")]` (no `api/`
 * prefix) and the gateway in front of `VITE_API_BASE_URL` does not strip a
 * controller-level segment, so the relative path is `CventSync/...`.
 *
 * Mirrors `SyncJobModel.GetSyncJobList`:
 *   GET CventSync/GetSyncJobGridPaginated
 *       ?CurrentPage=&PageSize=&Skip=&SearchParam=
 *       &StartDate=&EndDate=&SortCol=&SortDir=
 *
 * Uses `URLSearchParams` rather than string interpolation so user-supplied
 * search text cannot be injected into the path.
 */
const CONTROLLER = 'CventSync';

function toIsoDate(value: Date): string {
  // yyyy-MM-dd is unambiguous and accepted by the .NET model binder
  // regardless of the server culture.
  const y = value.getFullYear();
  const m = String(value.getMonth() + 1).padStart(2, '0');
  const d = String(value.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export async function fetchSyncJobs(query: SyncJobsQuery): Promise<SyncJobsPage> {
  const skip = (query.page - 1) * query.pageSize;
  const qs = new URLSearchParams({
    CurrentPage: String(query.page),
    PageSize: String(query.pageSize),
    Skip: String(skip),
    SearchParam: query.searchParam,
    StartDate: toIsoDate(query.startDate),
    EndDate: toIsoDate(query.endDate),
    SortCol: query.sortCol,
    SortDir: query.sortDir,
  });
  return apiGet<SyncJobsPage>(`${CONTROLLER}/GetSyncJobGridPaginated?${qs}`);
}
